module.exports = __webpack_public_path__ + "img/map_clock_icon.244d30ce.svg";